

export default class StyleProvider {


    static GetStyles(width, height) {

        return {
            appLayout: { position: 'relative', height: '80vh', overflow: 'hidden', backgroundColor: '#dcdde1', fontFamily: 'sans-serif' },
            header: { position: 'fixed', top: 100, left: 210, right: 270, height: '60px', backgroundColor: '#2c3e50', color: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 24px', zIndex: 100 },
            sidebar: { position: 'fixed', top: '60px', left: 0, bottom: 0, width: '130px', backgroundColor: '#fff', borderRight: '1px solid #b2bec3', padding: '16px 40px', display: 'flex', flexDirection: 'column', gap: '8px', zIndex: 90 },
            inspectorPanel: { position: 'fixed', top: '60px', right: 0, bottom: 0, width: '240px', backgroundColor: '#fff', borderLeft: '1px solid #b2bec3', padding: '20px 16px', zIndex: 90 },

            canvasContainer: {
                position: 'absolute',
                top: '60px',
                left: '154px',
                right: '240px',
                bottom: '0px',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxSizing: 'border-box',
                padding: '20px',
                height: '75vh',
                marginRight: '300px'
            },

            canvasMount: {
                width: width + 'px',   // Strict 300px width
                height: height + 'px',  // Strict 200px height
                backgroundColor: '#fff',
                boxShadow: '0px 10px 30px rgba(0,0,0,0.1)',
                border: '1px solid #7f8c8d',
                position: 'relative',
                boxSizing: 'border-box'
            },

            toolBtn: { width: '100%', padding: '11px 6px', border: '1px solid #dcdde1', borderRadius: '6px', cursor: 'pointer', fontSize: '11px', fontWeight: 'bold', backgroundColor: '#f5f6fa' },
            btn: { padding: '8px 14px', border: '1px solid #bdc3c7', borderRadius: '4px', backgroundColor: '#fff', cursor: 'pointer', fontSize: '13px' },
            sectionTitle: { margin: '0 0 12px 0', fontSize: '14px', color: '#7f8c8d', textTransform: 'uppercase' },
            label: { display: 'block', marginTop: '20px', marginBottom: '6px', fontSize: '12px', fontWeight: 'bold' },
            colorInput: { border: '1px solid #ccc', borderRadius: '4px', width: '50px', height: '35px', cursor: 'pointer' },
            textInput: { border: '1px solid #ccc', borderRadius: '4px', width: '100%', padding: '8px', boxSizing: 'border-box', fontSize: '13px' },
            selectInput: { border: '1px solid #ccc', borderRadius: '4px', width: '100%', padding: '8px', boxSizing: 'border-box', fontSize: '13px', backgroundColor: '#fff' }
        };


    }



}
